import axiosInstance from '../utils/axiosInstance';

export type TrialStatusKey =
  | 'trialing'
  | 'trial_expired'
  | 'paid'
  | 'free'
  | 'past_due'
  | 'canceled';

export type AccessBlockedReason = 'trial_expired' | 'usage_limit';

export interface TrialStatus {
  status: TrialStatusKey;
  tier: 'trial' | 'free' | 'basic' | 'pro';
  trialExpiresAt?: string;
  daysLeft?: number;
  spentUsd: number;
  capUsd: number | null;
  blocked: boolean;
  blockedReason?: AccessBlockedReason;
}

export async function getTrialStatus(): Promise<TrialStatus> {
  const res = await axiosInstance.get<{ success: boolean; data: TrialStatus }>(
    '/subscription/trial-status',
  );
  return res.data.data;
}
